import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* initLargeUpload<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.LARGE_UPLOAD.INIT, action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError(
            e?.response?.data ||
                e.data || {
                    message: e?.message || 'Failed to initialise large upload session',
                    status_code: e?.status || 500,
                    success: false,
                },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'initLargeUpload', action: action?.type })
    }
}

export function* uploadChunk<P, R>(action: {
    type: string
    payload: {
        formData: FormData
        progress?: (progressEvent: any) => void
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const data = action.payload.formData
        const resp = yield call(CallApi.POST, APIS.LARGE_UPLOAD.UPLOAD_CHUNK, data, true, (progressEvent: any) => {
            if (action?.payload?.progress) {
                action.payload.progress(progressEvent)
            }
        })
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError(
            e?.response?.data || {
                message: e?.message || 'Failed to upload chunk',
                status_code: e?.status || 500,
                success: false,
                reserved_columns: e?.error?.reserved_columns || null,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'uploadChunk', action: action?.type })
    }
}

export function* completeLargeUpload<R>(action: { type: string; payload: { upload_id: string }; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.LARGE_UPLOAD.COMPLETE(action.payload.upload_id), action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError(
            e?.response?.data || {
                message: e?.message || 'Failed to complete large upload',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'completeLargeUpload', action: action?.type })
    }
}

export function* getLargeUploadStatus<R>(action: { type: string; payload: { upload_id: string }; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.LARGE_UPLOAD.GET_STATUS(action.payload.upload_id), null, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError(
            e?.response?.data || {
                message: e?.message || 'Failed to get upload status',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getLargeUploadStatus', action: action?.type })
    }
}

export function* processLargeUpload<R>(action: { type: string; payload: { upload_id: string }; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.LARGE_UPLOAD.PROCESS(action.payload.upload_id), {}, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError(
            e?.response?.data || {
                message: e?.message || 'Failed to process large upload',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'processLargeUpload', action: action?.type })
    }
}

export function* rejectLargeUpload<R>(action: { type: string; payload: { upload_id: string }; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.LARGE_UPLOAD.REJECT(action.payload.upload_id), action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError(
            e?.response?.data || {
                message: e?.message || 'Failed to reject upload session',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'rejectLargeUpload', action: action?.type })
    }
}
